import { PiTruck } from 'react-icons/pi';
import { Button } from '@v2/design-system';

type Props = {
    count: number;
    loading: boolean;
    onCreate: () => void;
    onClear: () => void;
};

export default function PloomesDealBulkBar({ count, loading, onCreate, onClear }: Props) {
    if (count === 0) {
        return null;
    }

    return (
        <div className={[
            'sticky top-0 z-10 mb-3 flex flex-wrap items-center justify-between gap-3 rounded-lg border px-4 py-3 text-sm shadow-sm',
            'border-emerald-200 bg-emerald-50 text-emerald-900',
            'dark:border-emerald-900/50 dark:bg-emerald-950/40 dark:text-emerald-300',
        ].join(' ')}>
            <p className="font-medium">
                {count} proposta{count !== 1 ? 's' : ''} selecionada{count !== 1 ? 's' : ''}
            </p>
            <div className="flex flex-wrap items-center gap-2">
                <Button size="sm" variant="outline" onClick={onClear} disabled={loading}>
                    Limpar seleção
                </Button>
                <Button
                    size="sm"
                    onClick={onCreate}
                    isLoading={loading}
                    className="bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-600"
                >
                    <PiTruck className="me-1.5 h-4 w-4" />
                    Criar requisição de importação
                </Button>
            </div>
        </div>
    );
}
